import React, { useState } from 'react';
import '../../style/style.css';
import Navbar from '../../componentes/nav';
import Footer from '../../componentes/folter';


function Transparencia() {

    return (

        <>
            <Navbar />

            <main className='mainBoletim'>

                <div id="transparencia" class="transparencia">
                    <h2>Transparência e Publicações</h2>

                    <h2>2025</h2>


                    

                    <a href="https://drive.google.com/file/d/1b4ooWZKJTcD0ne3EaGJMIfcRW6mIHeZT/view?usp=sharing">


                        <h3>CARTILHA CONECTA VIDAS - Vol. 01</h3>

                    </a>

                    

                    <a href="https://drive.google.com/file/d/1fSscB0xDdqcFRuWlMXlA0yzHCs6Ibxyz/view?usp=sharing">


                        <h3>NOTA TÉCNICA - SEE - Gerência Geral de Assuntos Jurídicos - Nº 13832025</h3>

                    </a>



                    <a href="https://drive.google.com/file/d/1_Km9g0wVQ_O734elQUBYzdqXrCusMZK5/view?usp=sharing">


                        <h3>CÓDIGO DE ÉTICA E CONDUTA</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1rg2DA3YEt3fDJw5nZ5dex3r-w0xn59td/view?usp=sharing">


                        <h3>PLANO DE CAPTAÇÃO DE RECURSOS</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1C49J0njGEiV4scfG53RaWvB4BHr-ZBbQ/view?usp=sharing">


                        <h3>PLANO OPERACIONAL ANUAL - POA/2025</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1U1Ud2oOFH1Kz8BFNiS75tEknozHzFVL9/view?usp=sharing">


                        <h3>PLANEJAMENTO ESTRATÉGICO E PLANO DE AÇÃO UTILIZADO EM 2025</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1bQqIlDw4zkGabDfXYrWzOIKbuk1PNTXE/view?usp=sharing">


                        <h3>PLANO ESTRATÉGICO DE COMUNICAÇÃO</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1QoDylPQ3JEHqOY77lpD5J9opIA5XQQaZ/view?usp=sharing">


                        <h3>TERMO DE FOMENTO N 004-2025</h3>

                    </a>


                    <a href="https://drive.google.com/file/d/1VCRWG5O22GjNcsqbpWt4fr1wTeYr2NLU/view?usp=sharing">



                        <h3>TERMO DE FOMENTO N 009-2025</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1V7haPwJ1huychyRuSJEj4rIX4naJGpeS/view?usp=sharing">


                        <h3>EDITAL DE SELEÇÃO SIMPLIFICADA CHAMADA N 001-2025</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1XV9zAfDSRiPCmbmdrAhYZOmQ834qfS8p/view?usp=sharing">


                        <h3>COMISSÃO PERMANENTE DE COMPRAS - 2025</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1jyBZr6cQvxtjhsehnCRt8Afo7ZtKqJOW/view?usp=sharing">


                        <h3>POLÍTICA DE SALVAGUARDA - 2025</h3>

                    </a>


                    <h2>2024</h2>

                    <a href="https://drive.google.com/file/d/1oEoZFEJoOKJrTkl_GmsU7DK9i29hjIO1/view?usp=sharing">

                        <h3>RELATÓRIO ANUAL DE IMPACTO 2024</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/12oOHysq9BkZ29unW3_I4qamhNvCdX_GH/view?usp=sharing">

                        <h3>BALANCETE 2024</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1J0NJWMaYmGw-0JBwuNG0wmEhKYD3YHA_/view?usp=sharing">

                        <h3>TERMO DE CONVÊNIO - PROJETO OPORTUNIZAR COMUNIDADE URBANO</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1pGmAdXpbaEnILCjYhW5Xs-Cut2g29hNn/view?usp=sharing">

                        <h3>TERMO DE FOMENTO - N° 023 - 2024</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1mTX0UbMRJsrvar8FkOoQ3SqdrF2S0orb/view?usp=sharing">

                        <h3>TERMO DE FOMENTO - N° 003 - 2024</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1I-NlMv1qLUmt_yEC33nhCZeWtRkgV-ax/view?usp=sharing">

                        <h3>TERMO DE FOMENTO - N° 005 - 2024</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1H_XUtHJvKhOrqBIgEwXWWvCW9NGYBhnK/view?usp=sharing">

                        <h3>TERMO DE FOMENTO - N° 009 - 2024</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1f62vhhLa-eANMVZnWVozVDVJwUY9NXO_/view?usp=sharing">

                        <h3>TERMO DE FOMENTO 006-2024</h3>

                    </a>




                    <h2>2023</h2>


                    <a href="https://drive.google.com/file/d/1M9mryRTMrsadPsUj47MEj9adEeUSJMKG/view?usp=sharing">

                        <h3>RELATÓRIO DE IMPACTO - 2023</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/17HGINeyr4DVDyGHbq7yE96oxsOUIqEYj/view?usp=sharing">

                        <h3>TERMO DE FOMENTO N 002-2023</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1HQ2QMto9GxKvTb5jCD6k8Vg13Y0ntHBc/view?usp=sharing">

                        <h3>TERMO DE FOMENTO N 007-2023</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/13cfnWMIO4q9VDincc9FrxBpS_LY0xl2V/view?usp=sharing">

                        <h3>TERMO DE CONVÊNIO - 2023</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1vRbRe-kgfH_ZktegxJvGQe3XQt-Wr7RH/view?usp=sharing">

                        <h3>REGULAMENTO DE COMPRAS - 2023</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1rmyglMRgigWh9grhAyypdMdVToG8cALC/view?usp=sharing">

                        <h3>AUTORIZAÇÃO CAPTAÇÃO DE RECURSOS - 2023</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1ond-hF-7ZDgfbSkWrSMCyHcNz8d-lnEb/view?usp=sharing">

                        <h3>BALANÇO - 2023</h3>

                    </a>




                    <h2>2022</h2>


                    <a href="https://drive.google.com/file/d/19cwQpESFd44Sce6CDSUz9L78wIF_19Dp/view?usp=sharing">

                        <h3>TERMO DE FOMENTO - VAMOSIMBORA? - 2022</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/13AcTdwZr2HzF8LtFucacJ5DLIOf1_eNx/view?usp=sharing ">

                        <h3>RELATÓRIO EXECUTIVO - 2022</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1xADMx3TJTYRRvyh-c4dadCx_ph6jnqgO/view?usp=sharing">

                        <h3>BALANÇO - 2022</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1an-7fjlJZ11OZRFVZdRBq2OqgYEIRpMC/view?usp=sharing">

                        <h3>BALANCETE - 2022</h3>

                    </a>



                    <h2>2021</h2>

                    <a href="https://drive.google.com/file/d/1U_saC2n3qxLKgXKTwykTCXLYMWvoG8MJ/view?usp=sharing">

                        <h3>RELATÓRIO EXECUTIVO - 2021</h3>

                    </a>

                    <a href="https://drive.google.com/file/d/1jc13RpPucq9XXbqFRrfdlkF_SIIyljDq/view?usp=sharing
">

                        <h3>BALANCETE - 2021</h3>

                    </a>

                    <h2>2020</h2>

                    <a href="https://drive.google.com/file/d/1BK2K-pN6aTzv2DoY4JdMsGQyQaXvOs-e/view?usp=sharing">

                        <h3>BALANCETE - 2020</h3>

                    </a>



                </div>



            </main>

            <Footer />

        </>
    );
}

export default Transparencia;
